import { RandomGenerator } from '@grandom/core';
export default class RandomBoolean extends RandomGenerator {
    boolean(arg1) {
        if (typeof arg1 !== 'undefined') {
            if (typeof arg1 !== 'number') {
                throw new TypeError(`bias must be a number, got: ${typeof arg1}.`);
            }
            // NaN guard
            // eslint-disable-next-line no-self-compare
            if (arg1 === arg1) {
                if (arg1 < 0) {
                    arg1 = 0;
                }
                else if (arg1 > 1) {
                    arg1 = 1;
                }
                return this._engine.nextFloat() < arg1;
            }
        }
        return this._engine.nextBoolean();
    }
}
//# sourceMappingURL=index.js.map